import React from 'react'
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
 function Registro
() {
  return (
    <div>
      <div>
 
  <title>Registrarse</title>
  
  <link href="css/sb-admin-2.min.css" rel="stylesheet" />
  <div className="container">
    <div className="card o-hidden border-0 shadow-lg my-5">
      <div className="card-body p-0">
        {/* Nested Row within Card Body */}
        <div className="row">
          <img src="https://www.icontec.org/wp-content/uploads/2019/08/1as-Logo-SUA-2017.jpg" />
          <div className="col-lg-6">
            <div className="p-5">
              <div className="text-center">
                <h1 className="h4 text-gray-900 mb-4">Solicitud de Registro!</h1>
              </div>
              <form className="user">
                <div className="form-group row">
                  <div className="col-sm-6 mb-3 mb-sm-0">
                    <input type="text" className="form-control form-control-user" id="NOMBRE" placeholder="Nombre" />
                  </div>
                </div>
                <div className="form-group">
                  <input type="email" className="form-control form-control-user" id="CORREO" placeholder="correo" />
                </div>
               
                <a href="login.html" className="btn btn-primary btn-user btn-block">
                 Enviar
                </a>
                <hr />
              </form>
              <div className="text-center">
              <a> <Link to={'/RecuperarContrasena'}> Olvide mi contraseña</Link></a>
              </div>
              <div className="text-center">
              <a> <Link to={'/Login'}> Ya tienes cuenta?</Link></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

    </div>
  )
}
export default Registro
